import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Panel } from '../../components/Panel'
import { visitorsApi } from '../../api/visitors'
import { fmtDateTime, fmtInt, PUBLICATION_NAMES } from '../../lib/format'
import { duration } from '../../lib/visitorsFormat'
import { useVisitorsRange } from '../../lib/useVisitorsRange'
import { QueryProblem, Skeleton, VisitorsFrame, linkCls, tdn, th, thr } from './VisitorsFrame'

export function VisitorsVisitor() {
  const { pub = '', visitorId = '' } = useParams()
  const { search } = useVisitorsRange()
  const okPub = Object.hasOwn(PUBLICATION_NAMES, pub)
  const q = useQuery({
    queryKey: ['visitors-visitor', pub, visitorId],
    queryFn: () => visitorsApi.visitor(pub, visitorId),
    enabled: okPub && visitorId !== '',
    retry: false,
  })
  const base = `/visitors/${pub}`
  const d = q.data
  return (
    <VisitorsFrame pub={pub} valid={okPub} title={`Visitor ${visitorId.slice(0, 8)}`} crumbs={[{ label: `Visitor ${visitorId.slice(0, 8)}` }]}>
      {q.isError ? (
        <QueryProblem error={q.error} pub={pub} />
      ) : !d ? (
        <Skeleton h="h-64" />
      ) : (
        <>
          <p className="font-mono text-[12px] text-paper-dim break-words">Visitor {d.visitor_id} · {fmtInt(d.sessions.length)} visits shown (newest 200)</p>
          {d.linked_subscriber_ids.length > 0 && (
            <p className="font-mono text-[12px] text-paper-dim">
              Linked members:{' '}
              {d.linked_subscriber_ids.map((id) => <Link key={id} to={`${base}/members/${id}?${search}`} className={`${linkCls} mr-3`}>#{id}</Link>)}
            </p>
          )}
          <Panel label="Visits" accent="cyan" bodyClassName="p-0">
            <div className="overflow-x-auto">
              <table className="w-full font-mono text-[12px] text-paper">
                <thead>
                  <tr className="border-b border-ink-500">
                    {['Started', 'Channel', 'Landing'].map((h) => <th key={h} className={th}>{h}</th>)}
                    {['Pages', 'Engaged'].map((h) => <th key={h} className={thr}>{h}</th>)}
                    <th className={th}>Verdict</th>
                  </tr>
                </thead>
                <tbody>
                  {d.sessions.map((s) => (
                    <tr key={s.session_id} className="border-b border-ink-500/50">
                      <td className="px-3 py-2 whitespace-nowrap"><Link to={`${base}/sessions/${encodeURIComponent(s.session_id)}?${search}`} className={linkCls}>{fmtDateTime(s.started_at)}</Link></td>
                      <td className="px-3 py-2">{s.channel ?? '—'}</td>
                      <td className="px-3 py-2 max-w-[260px] truncate" title={s.landing_path ?? ''}>{s.landing_path ?? '—'}</td>
                      <td className={tdn}>{fmtInt(s.page_count)}</td>
                      <td className={tdn}>{duration(s.engaged_ms)}</td>
                      <td className="px-3 py-2">{s.verdict}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Panel>
        </>
      )}
    </VisitorsFrame>
  )
}
